<script>
    import Card from "../shared/Card.svelte";
    import Button from "../shared/Button.svelte";
    import { _ } from "svelte-i18n";

    export let download;
    export let local_title;
    export let local_desc;
</script>

<Card>
  <div class="download">
    <h4 class="dl-title">{local_title} <span class="dl-fsize">&#8226 {download.fsize}</span></h4>
    <a href={download.href} class="dl-href" download><Button flat={true} inverse={false}>{$_("button-1")}</Button></a>
    <p class="dl-desc">{local_desc}</p>
    <div class="dl-type unselectable" class:exe={download.type === "EXE"} class:ipynb={download.type === "IPYNB"} class:json={download.type === "JSON"} class:pdf={download.type === "PDF"}>
      <p>
        {#if download.type === "EXE"}
          <span class="fa fa-arrow-pointer" />
        {/if}
        {#if download.type === "IPYNB"}
          <span class="fa fa-laptop-code" />
        {/if}
        {#if download.type === "JSON"}
          <span class="fa fa-code" />
        {/if}
        {#if download.type === "PDF"}
          <span class="fa fa-file" />
        {/if}
        {download.type}
      </p>
    </div>
  </div>
</Card>

<style>
  .download {
    display: grid;
    grid-template-columns: 70% 30%;
    gap: 10px;
  }
  .dl-title {
    margin: auto 0;
  }
  .dl-fsize {
    font-weight: normal;
    color: #bbb;
  }
  .dl-href {
    text-align: center;
  }
  .dl-desc {
    margin: auto 0;
    color: #888;
  }
  .dl-type {
    text-align: center;
    font-weight: bold;
  }
  .dl-type p {
    margin: 0;
  }
  .exe {
    color: #1AEB7E
  }
  .ipynb {
    color: #32D3EB
  }
  .json {
    color: #EBCB0E
  }
  .pdf {
    color: #EB4F3D
  }
</style>